import ActionTypes from '../actions';

const initialState = {
  isFetching: false,
  timeslots: [],
};

export const AppointmentTimePickerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      state = { ...state, timeslots: action.data, isFetching: false };
      break;
    case ActionTypes.FETCHING:
      state = { ...state, isFetching: true, timeslots: [] };
      break;
    default:
      break;
  }

  return state;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/reducer/AppointmentTimePickerReducer.js